var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1540_262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1540_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0502 23.2363C30.7373 23.2363 23.1863 30.7874 23.1863 40.1003C23.1863 49.4132 30.7373 56.9642 40.0502 56.9642C49.3632 56.9642 56.9142 49.4132 56.9142 40.1003C56.8638 30.7874 49.3128 23.2363 40.0502 23.2363Z",
    fill: "#3880FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2138 24.7473C68.4675 24.7473 71.9158 21.299 71.9158 17.0453C71.9158 12.7916 68.4675 9.34326 64.2138 9.34326C59.96 9.34326 56.5117 12.7916 56.5117 17.0453C56.5117 21.299 59.96 24.7473 64.2138 24.7473Z",
    fill: "#3880FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6776 24.7469L73.3755 24.0422L72.8721 24.6463C71.6136 26.0558 70.0027 27.1633 68.2408 27.8177L67.7374 28.019L67.9388 28.5224C69.4993 32.1973 70.2544 36.1238 70.2544 40.1007C70.2544 56.7633 56.7129 70.3551 40 70.3551C23.2871 70.3551 9.79592 56.7633 9.79592 40.1007C9.79592 23.4381 23.3374 9.84625 40.0503 9.84625C44.581 9.84625 48.9102 10.8531 52.9878 12.766L53.4408 12.9673L53.6422 12.4639C54.3973 10.702 55.5551 9.19183 57.0653 7.98367L57.6694 7.48027L56.9646 7.12789C51.6789 4.40952 45.9905 3 40 3C19.6122 3 3 19.6122 3 40C3 60.3878 19.6122 77 40 77C60.3878 77 77 60.3878 77 40C77 34.7646 75.8925 29.6299 73.6776 24.7469Z",
    fill: "#3880FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/Ionic.46ad3520373edd717593ffc20ae15511.svg";
export { ForwardRef as ReactComponent };